<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">
        <select-cus @change="cusChange"></select-cus>
        <div class="date-picker-v2" :class="{ ml16: cusListTotal.length > 1 }">
          <el-date-picker class="query-date-picker" v-model="wageMonthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" :start-placeholder="$t('from')" :end-placeholder="$t('to')" @change="getData"></el-date-picker>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.idCards" multiple collapse-tags :placeholder="$t('selectStaff')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName" />
          </el-select>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.costCenters" multiple collapse-tags :placeholder="$t('selectCostCenter')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.costCenter" :key="item.id" :value="item.costName" :label="item.costName" />
          </el-select>
        </div>
        <div class="select-v2">
          <bsp-dicts-select class="query-select" v-model="queryParams.taxTypes" multiple collapse-tags :placeholder="$t('selectTaxType')" filterable clearable @change="handleSelectChange" @visible-change="handleSelectVisibleChange" :optionsList="dictData.taxType" v-if="dictData.taxType.length"></bsp-dicts-select>
        </div>
      </div>
      <div class="title-right">
        <el-button plain class="button-v2" @click="customHeaderModalShow = true">{{ $t('displayItemConfiguration') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">{{ $t('export') }}</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        v-if="render"
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
        show-footer
        :footer-method="footerMethod"
      >
        <template #operation="{ row }">
          <span class="text-button" @click="toDetail(row)">查看明细</span>
        </template>
      </air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
    </div>

    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      :visible.sync="customHeaderModalShow"
      append-to-body
    >
      <customHeader :header-list.sync="headerList" report-type="员工收入汇总表"></customHeader>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="customHeaderModalShow = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveCustomHeader">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/v2/stats/emp-income'
import {queryEmpInfoListPage} from '@/api/v2/common'
import exportMethod from '@/util/export'
import customHeader from '@/components/v2/custom-header'
import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
import BspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
import { mapGetters } from 'vuex';
import { floatSumArray } from '@/util/util';
import { validatenull } from '@/util/validate';

export default {
  name: 'EmpIncomeDetail',
  components: {
    customHeader,
    SelectCus,
    BspDictsSelect
  },
  data() {
    return {
      render: false,
      loading: true,
      wageMonthRange: [],
      isSelectChange: false,
      queryParams: {
        startDate: undefined,
        endDate: undefined,
        idCards: [],
        costCenters: [],
        taxTypes: [],
        cusIds: [],
        page: 1,
        limit: 20,
        total: 0
      },
      dictMap: {},
      dictData: {
        emp: [],
        costCenter: [],
        taxType: []
      },
      columns: [],
      tableData: [],
      submitLoading: false,
      customHeaderModalShow: false,
      headerList: [],
    }
  },
  computed: {
    ...mapGetters(['cusListTotal'])
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.getEmpList()
      this.getData()
    },
    getData() {
      this.render = false
      this.loading = true
      if (this.$isNotEmpty(this.wageMonthRange)) {
        this.queryParams.startDate = this.wageMonthRange[0]
        this.queryParams.endDate = this.wageMonthRange[1]
      } else {
        this.queryParams.startDate = undefined
        this.queryParams.endDate = undefined
      }
      api.selectDataForSalaryGroupCount(this.queryParams).then(res => {
        const data = res.data.data
        data.customList.forEach(item => {
          item.title = item.columnName
          item.minWidth = 140
          if (item.field === 'empName' || item.field === 'idCard') {
            item.fixed = 'left'
          }
        })
        this.columns = data.customList
        if (!this.dictMap.taxType) {
          this.dictMap.taxType = this.$arrayToObj(data.taxType, 'codeItemId')
        }
        this.tableData = this.$handleTableDict(data.dataList, this.dictMap, '')
        this.queryParams.total = data.params.total
        this.dictData.costCenter = data.costCenter
        this.dictData.taxType = data.taxType
        this.render = true
        this.loading = false
      })
    },
    getEmpList() {
      queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
        this.dictData.emp = res.data.records
      })
    },
    handleSelectChange(val) {
      if (this.$isEmpty(val)) {
        // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
        this.getData()
        this.isSelectChange = false
      } else {
        this.isSelectChange = true
      }
    },
    handleSelectVisibleChange(val) {
      // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
      if (!val && this.isSelectChange) {
        this.getData()
        // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
        this.isSelectChange = false
      }
    },
    toDetail(row) {
      this.$setStore('empIncomeDetail_queryParams', {...this.queryParams, idCards: [row.idCard], page: 1, limit: 20})
      this.$go('/v2/stats/emp-income/detail')
    },
    saveCustomHeader() {
      if (this.$isEmpty(this.headerList)) {
        this.$msgError('显示项目不能为空')
        return
      }
      let param = {
        headers: this.headerList,
        reportType: '员工收入汇总表'
      }
      this.submitLoading = true
      api.updataSalaryGroupHeaderInfo(param).then(res => {
        if (res.data.code === 0) {
          this.customHeaderModalShow = false
          this.$msgSuccess('保存成功')
          this.getData()
        }
      }).finally(() => this.submitLoading = false)
    },
    handleExport() {
      this.$msgInfo('开始下载...')
      exportMethod({
        columns: this.$clone(this.columns),
        beanName: 'salaryHistoryServiceImpl',
        methodName: 'selectDataForSalaryGroupCountForExport',
        headerType: '1003',
        headerRowNum: 1,
        isSort: true,
        fileName: "员工收入汇总表.xlsx",
        ...this.queryParams,
        type: 'excel'
      }, '/wage', true)
    },
    // 客户筛选change事件
    cusChange({ data, checkedLabels, checkedValues }) {
      this.queryParams.cusIds = checkedValues;
      this.getData();
    },
    numToArray(list, field) {
      return list.map(item => {
        return validatenull(item[field]) ? 0 : item[field];
      })
    },
    sumNum (list, field) {
      const numArray = this.numToArray(list, field);
      return floatSumArray(numArray);
    },
    footerMethod ({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return this.$t('sum');
          } else {
            if (!validatenull(column.params)) {
              const { valueType } = column.params;
              if (valueType == '92420001' || valueType == '92420002') {
                return this.sumNum(data, column.property)
              }
              return null
            } else {
              return null
            }
          }
        })
      ]
    },
    // 输入框回车，调接口
    pageSizeChange(val) {
      this.queryParams = Object.assign(val);
      this.getData();
    }
  }
}
</script>
